import { absoluteUrl } from './siteOrigin';
import { seoConfig, seoQuoteByServiceSlug } from './seoConfig';

const PATH_MAP = {
  '/': seoConfig.home,
  '/gyik': seoConfig.gyik,
  '/rolunk': seoConfig.rolunk,
  '/adatkezelesi-tajekoztato': seoConfig.privacy,
  '/ajanlat': seoConfig.ajanlat,
  '/szolgaltatas/ikea-hazhozszallitas': seoConfig.ikea,
  '/szolgaltatas/csomagszallitas': seoConfig.nagyCsomag,
  '/szolgaltatas/butor-szallitas': seoConfig.butorszallitas,
  '/szolgaltatas/kerekpar-szallitas': seoConfig.kerekpar,
  '/szolgaltatas/koltoztetes': seoConfig.koltoztetes,
  '/szolgaltatas/raklapos-szallitas': seoConfig.raklap,
};

const NOINDEX_PATHS = new Set([
  '/login',
  '/forgot-password',
  '/dashboard',
  '/blpkmap',
  '/vegleges-megrendeles',
]);

function withCanonical(entry, pathname) {
  const path = entry.path != null ? entry.path : pathname;
  const canonical = absoluteUrl(path);
  const description = entry.description || seoConfig.home.description;
  return {
    title: entry.title,
    description,
    canonical,
    robots: entry.robots || 'index, follow',
    ogTitle: entry.ogTitle || entry.title,
    ogDescription: entry.ogDescription || description,
    ogUrl: canonical,
  };
}

export function getPageSeo(pathname) {
  const path = pathname.split('?')[0].replace(/\/$/, '') || '/';
  const normalized = path === '' ? '/' : path;

  if (NOINDEX_PATHS.has(normalized)) {
    if (normalized === '/vegleges-megrendeles') {
      return withCanonical(seoConfig.vegleges, normalized);
    }
    return withCanonical({ ...seoConfig.auth, path: normalized }, normalized);
  }

  if (normalized.startsWith('/ajanlat/')) {
    const slug = normalized.slice('/ajanlat/'.length);
    const quote = seoQuoteByServiceSlug[slug];
    if (quote) {
      return withCanonical({ ...quote, path: normalized }, normalized);
    }
    return withCanonical(
      {
        title: 'Ajánlatkérés – Move and Parcel',
        description: seoConfig.ajanlat.description,
        path: normalized,
      },
      normalized,
    );
  }

  const hit = PATH_MAP[normalized];
  if (hit) return withCanonical(hit, normalized);

  return withCanonical(
    { ...seoConfig.notFound, path: normalized },
    normalized,
  );
}
